import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import { request } from 'meinian-package/src/utils'
import { Dropdown, Ul, Li } from 'meinian-package/src/baseComponent'
import { MoreBtn } from 'component/waterfall.card/action'

export default ({ id, onClick }) => {
  const onEnd = async () => {
    const res = await request.post('/zhikuan/mn/sample/update-step-status', {
      sampleId: id,
      stepStatus: -1
    })
    if (res) {
      onClick?.(res)
    }
  }
  return <Dropdown
    trigger="hover"
    placement="bottomRight"
    overlay={<Ul style={{ width: 145 }}>
      <Li className="mn-dropdown-icon-li" onClick={onEnd}><Icon type="m-jianshao_miaobian" />终止流程</Li>
    </Ul>}
  >
    <MoreBtn style={{ cursor: 'pointer' }} />
    {/* <Button ghost style={{ width: 32, padding: '5px 0' }} className="action-button"><Icon style={{ fontSize: 20, verticalAlign: 'top' }} type="m-gengduo" /></Button> */}
  </Dropdown>
}
